// extracted by mini-css-extract-plugin
module.exports = {"favoriteButton":"propertyToFavorite_favoriteButton__1ju-7","iconButtonFavorite":"propertyToFavorite_iconButtonFavorite__dFJ70","favoriteTopBar":"propertyToFavorite_favoriteTopBar__2NZzr","primaryColors":"propertyToFavorite_primaryColors__pIbrE"};
    if(module.hot) {
      // 1744882468534
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  